export default "__VITE_ASSET__1328d90e__"